import React, { useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import './Solutions.css';
import manufacture from '../../assets/images/Manufacturing.png'
import education from '../../assets/images/education.png'
import retail from '../../assets/images/retails.jpeg'
import finance from '../../assets/images/finance.jpg'
import healthcare from '../../assets/images/health.jpg'
import energy from '../../assets/images/enrtgy.jpg'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SchoolIcon from '@mui/icons-material/School';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SavingsIcon from '@mui/icons-material/Savings';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import FlashAutoIcon from '@mui/icons-material/FlashAuto';



const TABS = [
  { key: "manufacturing", label: "Manufacturing", icon: <PrecisionManufacturingIcon fontSize="small"/>},
  { key: "education", label: "Education", icon: <SchoolIcon fontSize="small"/>},
  { key: "retail", label: "Retail", icon: <StorefrontIcon fontSize="small"/>},
  { key: "finance", label: "Finance", icon: <SavingsIcon fontSize="small"/>},
  { key: "healthcare", label: "Healthcare", icon: <MonitorHeartIcon fontSize="small"/>},
  { key: "energy", label: "Energy", icon: <FlashAutoIcon fontSize="small"/>},
];

const TAB_CONTENT = {
  manufacturing: {
    title: "AI Solutions for Manufacturing",
    desc: "Our AI solutions can help improve production efficiency, reduce downtime, and ensure quality control with our AI solutions designed specifically for manufacturing operations and supply chain optimization.",
    points: [
      "Predictive maintenance and equipment monitoring",
      "Quality control and defect detection",
      "Supply chain optimization",
      "Production planning and scheduling",
    ],
    image: manufacture,
  },
  education: {
    title: "AI Solutions for Education",
    desc: "Tailor learning experiences, automate administrative work, and boost student success using AI-powered educational tools for content personalization, assessment, and analytics.",
    points: [
      "Personalized learning pathways",
      "Automated grading and feedback",
      "Student performance analytics",
      "Intelligent content recommendations",
    ],
    image: education,
  },
  retail: {
    title: "AI Solutions for Retail",
    desc: "Increase sales and operational efficiency by leveraging AI-powered analytics, personalized recommendations, and demand forecasting tools for retail businesses.",
    points: [
      "Customer behavior analysis",
      "Personalized product recommendations",
      "Inventory and demand forecasting",
      "Automated customer support",
    ],
    image: retail,
  },
  finance: {
    title: "AI Solutions for Finance",
    desc: "Boost accuracy, security, and customer experience by automating risk analysis, fraud detection, and financial forecasting with AI-driven finance solutions.",
    points: [
      "Fraud detection and prevention",
      "Automated risk analysis",
      "Financial forecasting and planning",
      "Customer service automation",
    ],
    image: finance,
  },
  healthcare: {
    title: "AI Solutions for Healthcare",
    desc: "Enhance diagnostics, patient care, and hospital operations using AI-driven tools for medical imaging, administrative automation, and personalized treatments.",
    points: [
      "Medical image analysis",
      "Predictive diagnostics",
      "Smart scheduling & operations",
      "Personalized treatment planning",
    ],
    image: healthcare,
  },
  energy: {
    title: "AI Solutions for Energy",
    desc: "Optimize energy production and consumption, predict equipment failures, and manage smart grids using advanced AI analytics and automation for the energy sector.",
    points: [
      "Predictive maintenance for grids/plants",
      "Energy demand forecasting",
      "Anomaly detection in usage patterns",
      "Renewable integration management",
    ],
    image: energy,
  },
};

const IndustryAISolutions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<keyof typeof TAB_CONTENT>("manufacturing");
  const content = TAB_CONTENT[activeTab];
  return (
    <div className="industry-ai-bg">
      <Container>
        <div className="text-center mb-4">
          <h2 className="industry-section-title">
            Industry-Specific <span className="brand-gradient-text">AI Solutions</span>
          </h2>
          <div className="industry-section-subtitle mx-auto">
            We develop tailored AI solutions for various industries, addressing specific challenges and unlocking new opportunities.
          </div>
        </div>
        <div className="industry-tabs d-flex justify-content-center gap-2 mb-4 flex-wrap">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key as any)}
              className={`industry-tab-btn${activeTab === tab.key ? " active" : ""}`}
              type="button"
            >
              <span className="industry-tab-icon">{tab.icon}</span> {tab.label}
            </button>
          ))}
        </div>
        <div className="industry-card-wrap">
          <Row className="align-items-center">
            <Col md="7" lg="7">
              <div className="industry-card-content">
                <h3 className="industry-card-title">{content.title}</h3>
                <div className="industry-card-desc mb-3">{content.desc}</div>
                <ul className="industry-list">
                  {content.points.map((pt, idx) => (
                    <li key={idx}>
                      <span className="industry-list-icon">✔️</span>
                      {pt}
                    </li>
                  ))}
                </ul>
                <Button className="industry-learnmore-btn mt-3" color="primary">
                  Learn More &rarr;
                </Button>
              </div>
            </Col>
            <Col md="5" lg="5">
              <img src={content.image} alt={content.title} className="industry-card-img" />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default IndustryAISolutions;
